// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.awardTypesPage {
  min-height: calc(100vh - 64px);
  background: var(--surface-page, #f6f8fb);
  color: var(--text-body, #334155);
  padding: 18px 20px 40px;
}

.awardTypesShell {
  width: 100%;
  max-width: 1180px;
}

.awardTypesToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 14px;
}

.awardTypesToolbar__heading {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex-wrap: wrap;
}

.awardTypesToolbar h1 {
  margin: 0;
  font-family: var(--font-display, inherit);
  font-size: 22px;
  line-height: 1.2;
  font-weight: 800;
  color: var(--text-strong, #0f172a);
}

.awardTypesToolbar h1 span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 24px;
  margin-left: 8px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 800;
  vertical-align: middle;
}

.awardTypesToolbar p {
  margin: 5px 0 0;
  font-size: 14px;
  line-height: 1.45;
  color: var(--text-muted, #64748b);
}

.awardTypesToolbar__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.awardTypesSearch {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  width: 240px;
  height: 40px;
  margin: 0;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-subtle, #94a3b8);
}

.awardTypesSearch input {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-strong, #0f172a);
  font: inherit;
  font-size: 13px;
}

.awardTypesSearch:focus-within {
  border-color: var(--brand-500, #227ebd);
  box-shadow: 0 0 0 3px var(--brand-100, #d6e7f6);
}

.awardTypesIcon {
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
}

.awardTypesButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  padding: 0 13px;
  border-radius: var(--radius-md, 8px);
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 13px;
  line-height: 1;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.14s ease, border-color 0.14s ease, color 0.14s ease, box-shadow 0.14s ease;
}

.awardTypesToolbar .awardTypesButton {
  min-height: var(--control-h-md, 40px);
  height: var(--control-h-md, 40px);
}

.awardTypesButton:disabled {
  opacity: 0.65;
  cursor: default;
}

.awardTypesButton .awardTypesIcon {
  width: 16px;
  height: 16px;
}

.awardTypesButton--primary {
  background: var(--brand-600, #227ebd);
  border-color: var(--brand-600, #227ebd);
  color: #fff;
  box-shadow: none;
}

.awardTypesButton--primary:hover:not(:disabled) {
  background: var(--brand-700, #17689f);
  border-color: var(--brand-700, #17689f);
}

.awardTypesButton--ghost {
  background: transparent;
  border-color: transparent;
  color: var(--text-link, #1a6da3);
}

.awardTypesButton--ghost:hover:not(:disabled) {
  background: var(--blue-50, #eef6fc);
  border-color: transparent;
}

.awardTypesButton--danger {
  background: var(--red-500, #da4453);
  border-color: transparent;
  color: #fff;
  box-shadow: none;
}

.awardTypesButton--danger:hover:not(:disabled) {
  background: var(--red-600, #c4313f);
}

.awardTypesSelectionBar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  padding: 8px 14px;
  border: 1px solid var(--blue-100, #d4e8f6);
  border-radius: var(--radius-md, 8px);
  background: var(--blue-50, #eef6fc);
  box-shadow: none;
  font-size: 13px;
  font-weight: 600;
  color: var(--blue-700, #155d8c);
}

.awardTypesSelectionBar__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.awardTypesGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}

.awardTypesCard {
  position: relative;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.06));
  transition: box-shadow 0.15s ease, transform 0.15s ease, border-color 0.15s ease;
}

.awardTypesCard:hover {
  border-color: var(--border-strong, #94a3b8);
  box-shadow: var(--shadow-md, 0 4px 12px rgba(15, 23, 42, 0.09));
}

.awardTypesCard--selected {
  border-color: var(--brand-300, #9cc4e8);
  box-shadow: 0 0 0 3px var(--brand-100, #d6e7f6);
}

.awardTypesCard__body {
  display: block;
  width: 100%;
  min-height: 168px;
  padding: 14px;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.awardTypesCard__checkbox {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  width: 23px;
  height: 23px;
  margin: 0;
  cursor: pointer;
}

.awardTypesCard__checkbox input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.awardTypesCard__checkbox span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 23px;
  height: 23px;
  border: 1.5px solid var(--border-strong, #94a3b8);
  border-radius: 6px;
  background: var(--surface-card, #fff);
  color: #fff;
}

.awardTypesCard__checkbox input:checked + span {
  border-color: var(--brand-600, #227ebd);
  background: var(--brand-600, #227ebd);
}

.awardTypesCard__checkbox .awardTypesIcon {
  width: 14px;
  height: 14px;
  stroke-width: 3;
}

.awardTypesCard__top {
  display: flex;
  align-items: center;
  gap: 11px;
  padding-right: 30px;
  margin-bottom: 9px;
}

.awardTypesCard__main {
  min-width: 0;
}

.awardTypesCard__name {
  margin-bottom: 5px;
  color: var(--text-strong, #0f172a);
  font-size: 14px;
  line-height: 1.25;
  font-weight: 800;
}

.awardTypesCard p {
  min-height: 36px;
  margin: 0 0 10px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.4;
}

.awardTypesCard__footer {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  padding-top: 10px;
  border-top: 1px solid var(--border-subtle, #dbe3ed);
}

.awardTypesTile {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 1px solid var(--border-subtle, #dbe3ed);
  border-radius: var(--radius-md, 8px);
  overflow: hidden;
  background: var(--surface-card, #fff);
}

.awardTypesTile img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.awardTypesTile--generated {
  border-color: transparent;
}

.awardTypesTile--generated .awardTypesIcon {
  width: 52%;
  height: 52%;
  stroke-width: 2;
}

.awardTypesPoints,
.awardTypesStatus,
.awardTypesMiniChip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1;
  font-weight: 800;
}

.awardTypesPoints {
  background: var(--brand-50, #eaf4fb);
  color: var(--brand-700, #17689f);
}

.awardTypesPoints--negative {
  background: #fdeef0;
  color: #c23648;
}

.awardTypesPoints .awardTypesIcon {
  width: 13px;
  height: 13px;
  fill: currentColor;
}

.awardTypesStatus {
  height: 22px;
  padding: 0 9px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11px;
}

.awardTypesStatus--enabled {
  background: #e7f3ec;
  color: #2f9e5a;
}

.awardTypesStatus i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--text-subtle, #94a3b8);
}

.awardTypesStatus--enabled i {
  background: #2f9e5a;
}

.awardTypesMiniChip {
  height: 22px;
  padding: 0 8px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 700;
}

.awardTypesMiniChip--danger {
  background: #fdeef0;
  color: #c23648;
}

.awardTypesRolesCount {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-left: auto;
  color: var(--text-subtle, #94a3b8);
  font-size: 11.5px;
  font-weight: 700;
}

.awardTypesRolesCount .awardTypesIcon {
  width: 13px;
  height: 13px;
}

.awardTypesDrawerOverlay,
.awardTypesModalOverlay {
  position: fixed;
  inset: 0;
  z-index: 1040;
  background: rgba(15, 23, 42, 0.28);
}

.awardTypesDrawerOverlay {
  display: flex;
  justify-content: flex-end;
}

.awardTypesDrawer {
  display: flex;
  flex-direction: column;
  width: min(500px, 100vw);
  height: 100%;
  background: var(--surface-card, #fff);
  box-shadow: -14px 0 36px rgba(15, 23, 42, 0.18);
}

.awardTypesDrawer__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ed);
}

.awardTypesDrawer__header h2 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-size: 18px;
  line-height: 1.25;
  font-weight: 800;
}

.awardTypesDrawer__header p {
  margin: 3px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  font-weight: 650;
}

.awardTypesDrawer__header > div:nth-child(2) {
  flex: 1;
  min-width: 0;
}

.awardTypesIconButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid var(--border-subtle, #dbe3ed);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-muted, #64748b);
  cursor: pointer;
}

.awardTypesDrawer__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 18px 20px 20px;
}

.awardTypesDrawer__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid var(--border-subtle, #dbe3ed);
  background: var(--surface-card, #fff);
}

.awardTypesPreviewCard {
  display: flex;
  align-items: center;
  gap: 13px;
  margin-bottom: 18px;
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #dbe3ed);
  border-radius: 12px;
  background: var(--slate-25, #f8fafc);
}

.awardTypesPreviewCard > div > div:first-child {
  margin-bottom: 5px;
  color: var(--text-strong, #0f172a);
  font-size: 15px;
  font-weight: 800;
}

.awardTypesField {
  margin-bottom: 17px;
}

.awardTypesField label {
  display: block;
  margin-bottom: 7px;
  color: var(--text-strong, #0f172a);
  font-size: 12.5px;
  line-height: 1.2;
  font-weight: 750;
}

.awardTypesInput {
  width: 100%;
  min-height: 42px;
  padding: 0 13px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 9px;
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font: inherit;
  font-size: 14px;
}

.awardTypesTextarea {
  min-height: 82px;
  padding-top: 10px;
  line-height: 1.5;
  resize: vertical;
}

.awardTypesInput:focus {
  outline: none;
  border-color: var(--brand-500, #227ebd);
  box-shadow: 0 0 0 3px var(--brand-100, #d6e7f6);
}

.awardTypesArtworkRow {
  display: flex;
  align-items: center;
  gap: 16px;
}

.awardTypesArtworkRow p {
  margin: 8px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 12px;
}

.awardTypesUploadButton {
  position: relative;
  display: inline-flex !important;
  align-items: center;
  gap: 7px;
  width: auto;
  height: 36px;
  margin: 0 !important;
  padding: 0 14px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155) !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  cursor: pointer;
}

.awardTypesUploadButton input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.awardTypesRemoveImage {
  display: block;
  margin-top: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #c23648;
  font: inherit;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
}

.awardTypesStepper {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.awardTypesStepper button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 9px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  cursor: pointer;
}

.awardTypesStepper input {
  width: 76px;
  height: 38px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 9px;
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font: inherit;
  font-size: 16px;
  font-weight: 800;
  text-align: center;
}

.awardTypesSwitchGroup {
  margin: 4px 0 18px;
  border-top: 1px solid var(--border-subtle, #dbe3ed);
  border-bottom: 1px solid var(--border-subtle, #dbe3ed);
}

.awardTypesSwitchRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 13px 0;
}

.awardTypesSwitchRow + .awardTypesSwitchRow {
  border-top: 1px solid var(--border-subtle, #dbe3ed);
}

.awardTypesSwitchRow div div {
  color: var(--text-strong, #0f172a);
  font-size: 13.5px;
  font-weight: 750;
}

.awardTypesSwitchRow p {
  margin: 2px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  line-height: 1.35;
}

.awardTypesSwitch {
  display: inline-flex;
  justify-content: flex-start;
  flex: 0 0 auto;
  width: 46px;
  height: 27px;
  padding: 3px;
  border: 0;
  border-radius: 999px;
  background: var(--slate-300, #cbd5e1);
  cursor: pointer;
  transition: background 0.15s ease;
}

.awardTypesSwitch--on {
  justify-content: flex-end;
  background: var(--brand-600, #227ebd);
}

.awardTypesSwitch span {
  width: 21px;
  height: 21px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.3);
}

.awardTypesRolesGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 9px;
}

.awardTypesRoleChip {
  display: flex;
  align-items: center;
  gap: 9px;
  height: 42px;
  padding: 0 12px;
  border: 1px solid var(--border-subtle, #dbe3ed);
  border-radius: 9px;
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font: inherit;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
}

.awardTypesRoleChip--selected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.awardTypesRoleChip span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-subtle, #94a3b8);
}

.awardTypesRoleChip--selected span {
  background: var(--brand-600, #227ebd);
  color: #fff;
}

.awardTypesRoleChip .awardTypesIcon {
  width: 13px;
  height: 13px;
  stroke-width: 3;
}

.awardTypesAlert {
  margin-bottom: 16px;
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
}

.awardTypesAlert--danger {
  border: 1px solid #f4c9cf;
  background: #fdeef0;
  color: #8f2c39;
}

.awardTypesModalOverlay {
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.45);
}

.awardTypesModal {
  position: relative;
  width: min(460px, 100%);
  padding: 24px;
  border: 1px solid var(--border-subtle, #dbe3ed);
  border-radius: 16px;
  background: var(--surface-card, #fff);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.22);
}

.awardTypesModal__close {
  position: absolute;
  top: 14px;
  right: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--border-subtle, #dbe3ed);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-muted, #64748b);
  cursor: pointer;
}

.awardTypesModal__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-bottom: 14px;
  border-radius: 12px;
  background: #fdeef0;
  color: #c23648;
}

.awardTypesModal h2 {
  margin: 0 0 8px;
  color: var(--text-strong, #0f172a);
  font-size: 20px;
  line-height: 1.25;
  font-weight: 800;
}

.awardTypesModal p {
  margin: 0 0 16px;
  color: var(--text-body, #334155);
  font-size: 14px;
  line-height: 1.55;
}

.awardTypesModal__names {
  margin-bottom: 18px;
  padding: 11px 13px;
  border-radius: 10px;
  background: var(--slate-50, #f8fafc);
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 700;
}

.awardTypesModal__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.awardTypesToast {
  position: fixed;
  left: 50%;
  bottom: 24px;
  z-index: 1080;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-radius: 10px;
  background: #123651;
  color: #fff;
  font-size: 13.5px;
  font-weight: 700;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.28);
  transform: translateX(-50%);
}

.awardTypesToast .awardTypesIcon {
  color: #4fd18b;
}

.awardTypesEmpty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  padding: 32px;
  border: 1px solid var(--border-subtle, #dbe3ed);
  border-radius: 16px;
  background: var(--surface-card, #fff);
  text-align: center;
}

.awardTypesEmpty > div {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  margin-bottom: 14px;
  border-radius: 15px;
  background: var(--brand-50, #eaf4fb);
  color: var(--brand-600, #227ebd);
}

.awardTypesEmpty h2 {
  margin: 0 0 6px;
  color: var(--text-strong, #0f172a);
  font-size: 20px;
  font-weight: 800;
}

.awardTypesEmpty p {
  max-width: 440px;
  margin: 0 0 18px;
  color: var(--text-muted, #64748b);
  font-size: 14px;
  line-height: 1.5;
}

@media (max-width: 760px) {
  .awardTypesPage {
    padding: 18px 14px 36px;
  }

  .awardTypesToolbar,
  .awardTypesSelectionBar,
  .awardTypesDrawer__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .awardTypesToolbar__right,
  .awardTypesToolbar__heading,
  .awardTypesSearch,
  .awardTypesButton,
  .awardTypesSelectionBar__actions {
    width: 100%;
  }

  .awardTypesGrid {
    grid-template-columns: 1fr;
  }

  .awardTypesRolesGrid {
    grid-template-columns: 1fr;
  }
}

/* Modern list screen */
.awardTypesPage {
  width: 100%;
  min-height: 100%;
  margin-top: 0 !important;
  padding: 0 0 32px;
  background: transparent;
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
}

.awardTypesPageHeader {
  display: flex;
  width: calc(100% + 48px);
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin: -20px 0 18px -24px;
  padding: 0 72px 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.awardTypesPageHeader__title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.awardTypesPageHeader h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 22px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.015em;
  white-space: nowrap;
}

.awardTypesPageHeader__title > span {
  display: inline-flex;
  min-width: 24px;
  height: 22px;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11.5px;
  font-weight: 800;
}

.awardTypesShell {
  width: 100%;
  max-width: none;
}

.awardTypesListCard {
  position: relative;
  overflow: visible;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.awardTypesListToolbar {
  display: flex;
  min-height: 64px;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px 12px 0 0;
  background: var(--surface-card, #fff);
}

.awardTypesListToolbar .awardTypesSearch {
  width: min(420px, 100%);
  height: 38px;
  margin-right: 0;
  flex: 0 1 420px;
}

.awardTypesSearch > button {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 18px;
  cursor: pointer;
}

.awardTypesButton--secondary {
  border-color: var(--border-default, #cbd5e1);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
}

.awardTypesButton--secondary:hover:not(:disabled),
.awardTypesButton--secondary.is-active {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.awardTypesListToolbar .awardTypesButton {
  height: 38px;
  min-height: 38px;
}

.awardTypesButton__badge {
  display: inline-flex;
  min-width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11px;
  font-weight: 800;
}

.awardTypesButton--secondary.is-active .awardTypesButton__badge {
  background: var(--surface-card, #fff);
}

.awardTypesColumns {
  position: relative;
}

.awardTypesColumnsMenu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 30;
  width: 260px;
  padding: 8px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--surface-card, #fff);
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.16);
}

.awardTypesColumnsMenu header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 7px 8px 9px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  color: var(--text-strong, #0f172a);
  font-size: 12px;
}

.awardTypesColumnsMenu header button {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--blue-700, #155d8c);
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.awardTypesColumnsMenu label {
  display: flex;
  min-height: 38px;
  align-items: center;
  gap: 9px;
  margin: 0;
  padding: 0 8px;
  border-radius: 7px;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.awardTypesColumnsMenu label:hover {
  background: var(--surface-sunken, #f1f5f9);
}

.awardTypesColumnsMenu label.is-locked {
  color: var(--text-muted, #64748b);
  cursor: default;
}

.awardTypesColumnsMenu label input,
.awardTypesTable input[type='checkbox'] {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--action-primary, #227ebd);
}

.awardTypesColumnsMenu label small {
  margin-left: auto;
  color: var(--text-subtle, #94a3b8);
  font-size: 10px;
  font-weight: 700;
}

.awardTypesActiveFilters {
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.awardTypesActiveFilters > span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 4px;
  padding: 0 9px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 12px;
}

.awardTypesActiveFilters > span b {
  font-weight: 800;
}

.awardTypesActiveFilters button {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-weight: 800;
  cursor: pointer;
}

.awardTypesActiveFilters > span button {
  margin-left: 3px;
  font-size: 16px;
  line-height: 1;
}

.awardTypesActiveFilters > button {
  margin-left: 2px;
  color: var(--blue-700, #155d8c);
  font-size: 12px;
}

.awardTypesListCard .awardTypesSelectionBar {
  min-height: 48px;
  margin: 0;
  padding: 8px 16px;
  border-width: 0 0 1px;
  border-color: var(--blue-100, #d4e8f6);
  border-radius: 0;
}

.awardTypesListCard .awardTypesSelectionBar__actions {
  margin-left: auto;
}

.awardTypesTableScroll {
  width: 100%;
  overflow-x: auto;
}

.awardTypesTable {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  table-layout: auto;
}

.awardTypesTable th {
  height: 44px;
  padding: 0 14px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.045em;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}

.awardTypesTable th > button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
}

.awardTypesTable th > button span {
  color: var(--text-subtle, #94a3b8);
  font-size: 12px;
}

.awardTypesTable th > button span.is-active {
  color: var(--action-primary, #227ebd);
}

.awardTypesTable td {
  height: 56px;
  padding: 8px 14px;
  border-bottom: 1px solid var(--border-subtle, #e8edf2);
  color: var(--text-body, #334155);
  font-size: 13px;
  vertical-align: middle;
}

.awardTypesTable tbody tr {
  cursor: pointer;
}

.awardTypesTable tbody tr:hover,
.awardTypesTable tbody tr.is-selected,
.awardTypesTable tbody tr:focus {
  background: var(--blue-50, #eef6fc);
}

.awardTypesTable tbody tr:focus {
  outline: 2px solid var(--action-primary, #227ebd);
  outline-offset: -2px;
}

.awardTypesTable__check {
  width: 46px;
  padding-right: 6px !important;
  text-align: center !important;
}

.awardTypesTable__award {
  min-width: 320px;
}

.awardTypesAwardCell {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 11px;
}

.awardTypesAwardCell > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.awardTypesAwardCell strong {
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-size: 13.5px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.awardTypesAwardCell small {
  display: block;
  max-width: 460px;
  overflow: hidden;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.awardTypesTable .awardTypesTile {
  border-radius: 8px;
}

.awardTypesRoleList,
.awardTypesSettingsList {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

.awardTypesRoleList span,
.awardTypesSettingsList span {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-body, #334155);
  font-size: 10.5px;
  font-weight: 750;
  white-space: nowrap;
}

.awardTypesSettingsList span {
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.awardTypesSettingsList span.is-danger {
  background: #fdeef0;
  color: #a7283b;
}

.awardTypesRoleList em,
.awardTypesSettingsList em {
  color: var(--text-subtle, #94a3b8);
  font-size: 12px;
  font-style: normal;
}

.awardTypesTable__date {
  color: var(--text-muted, #64748b) !important;
  white-space: nowrap;
}

.awardTypesTable__open {
  width: 40px;
  padding-right: 12px !important;
  padding-left: 0 !important;
  text-align: center !important;
}

.awardTypesTable__open span {
  opacity: 0;
  color: var(--text-subtle, #94a3b8);
  font-size: 24px;
  line-height: 1;
  transition: opacity 0.12s ease;
}

.awardTypesTable tbody tr:hover .awardTypesTable__open span,
.awardTypesTable tbody tr:focus-within .awardTypesTable__open span {
  opacity: 1;
}

.awardTypesTable__empty {
  height: auto !important;
  padding: 32px 14px !important;
  color: var(--text-muted, #64748b) !important;
  text-align: center;
}

.awardTypesPagination {
  display: flex;
  min-height: 58px;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 0 0 11px 11px;
  background: var(--surface-card, #fff);
}

.awardTypesPagination > span {
  margin-right: auto;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 650;
}

.awardTypesPagination button {
  min-width: 34px;
  height: 34px;
  padding: 0 10px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.awardTypesPagination button:hover:not(:disabled),
.awardTypesPagination button.is-active {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.awardTypesPagination button:disabled {
  opacity: 0.45;
  cursor: default;
}

.awardTypesFilterOverlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  justify-content: flex-end;
  background: rgba(15, 23, 42, 0.24);
}

.awardTypesFilterDrawer {
  display: flex;
  width: min(440px, calc(100vw - 32px));
  height: 100vh;
  flex-direction: column;
  border-left: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);
}

.awardTypesFilterDrawer > header {
  display: flex;
  min-height: 76px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 22px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.awardTypesFilterDrawer > header h2 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, inherit);
  font-size: 22px;
  font-weight: 800;
}

.awardTypesFilterDrawer > header button {
  width: 34px;
  height: 34px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-muted, #64748b);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.awardTypesFilterDrawer__body {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 22px;
  overflow-y: auto;
  padding: 20px 22px 28px;
}

.awardTypesFilterDrawer__body .people-chipFilter + .people-chipFilter {
  padding-top: 18px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.awardTypesFilterDrawer__body .people-chipFilter__body {
  max-height: none;
  overflow: visible;
}

.awardTypesFilterDrawer > footer {
  display: flex;
  min-height: 66px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fafbfc);
}

.awardTypesFilterDrawer > footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.awardTypesEmpty {
  border-radius: var(--radius-lg, 12px);
}

@media (max-width: 1217px) {
  .awardTypesPageHeader {
    width: 100vw;
    margin-left: -12px;
    padding-right: 28px;
  }
}

@media (max-width: 760px) {
  .awardTypesPage {
    padding: 0 0 24px;
  }

  .awardTypesPageHeader {
    min-height: 74px;
    align-items: center;
    margin-bottom: 14px;
    padding: 10px 16px;
  }

  .awardTypesPageHeader .awardTypesButton {
    width: auto;
    flex: 0 0 auto;
  }

  .awardTypesListToolbar {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .awardTypesListToolbar .awardTypesSearch {
    width: 100%;
    flex: 1 0 100%;
  }

  .awardTypesColumns {
    flex: 1 1 auto;
  }

  .awardTypesColumns > .awardTypesButton,
  .awardTypesListToolbar > .awardTypesButton {
    width: 100%;
  }

  .awardTypesColumnsMenu {
    right: 0;
    left: auto;
  }

  .awardTypesListCard .awardTypesSelectionBar {
    flex-direction: row;
    align-items: center;
  }

  .awardTypesListCard .awardTypesSelectionBar__actions {
    width: auto;
  }

  .awardTypesListCard .awardTypesSelectionBar .awardTypesButton {
    width: auto;
  }

  .awardTypesFilterDrawer {
    width: 100vw;
  }

  .awardTypesFilterDrawer > footer {
    align-items: stretch;
    flex-direction: column;
  }

  .awardTypesFilterDrawer > footer > div,
  .awardTypesFilterDrawer > footer .awardTypesButton {
    width: 100%;
  }

  .awardTypesFilterDrawer > footer > div .awardTypesButton {
    flex: 1 1 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/AdminConsole/AwardTypes/AwardTypes.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yGAAyG;AAC3G;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,oCAAoC;EACpC,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;EACpC,qCAAqC;EACrC,8DAA8D;EAC9D,gFAAgF;AAClF;;AAEA;EACE,2CAA2C;EAC3C,+DAA+D;AACjE;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+CAA+C;EAC/C,oCAAoC;EACpC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;EACnD,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,qCAAqC;EACrC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,+CAA+C;EAC/C,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;;;IAKE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,8FAA8F;AAChG;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,sBAAsB;EACtB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sDAAsD;EACtD,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;EAEE,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,sDAAsD;EACtD,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sDAAsD;EACtD,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,sDAAsD;EACtD,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,oDAAoD;EACpD,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".awardTypesPage {\n  min-height: calc(100vh - 64px);\n  background: var(--surface-page, #f6f8fb);\n  color: var(--text-body, #334155);\n  padding: 18px 20px 40px;\n}\n\n.awardTypesShell {\n  width: 100%;\n  max-width: 1180px;\n}\n\n.awardTypesToolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  margin-bottom: 14px;\n}\n\n.awardTypesToolbar__heading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.awardTypesToolbar h1 {\n  margin: 0;\n  font-family: var(--font-display, inherit);\n  font-size: 22px;\n  line-height: 1.2;\n  font-weight: 800;\n  color: var(--text-strong, #0f172a);\n}\n\n.awardTypesToolbar h1 span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 26px;\n  height: 24px;\n  margin-left: 8px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 800;\n  vertical-align: middle;\n}\n\n.awardTypesToolbar p {\n  margin: 5px 0 0;\n  font-size: 14px;\n  line-height: 1.45;\n  color: var(--text-muted, #64748b);\n}\n\n.awardTypesToolbar__right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.awardTypesSearch {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  width: 240px;\n  height: 40px;\n  margin: 0;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-subtle, #94a3b8);\n}\n\n.awardTypesSearch input {\n  width: 100%;\n  min-width: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-strong, #0f172a);\n  font: inherit;\n  font-size: 13px;\n}\n\n.awardTypesSearch:focus-within {\n  border-color: var(--brand-500, #227ebd);\n  box-shadow: 0 0 0 3px var(--brand-100, #d6e7f6);\n}\n\n.awardTypesIcon {\n  width: 17px;\n  height: 17px;\n  flex: 0 0 auto;\n}\n\n.awardTypesButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 36px;\n  padding: 0 13px;\n  border-radius: var(--radius-md, 8px);\n  border: 1px solid transparent;\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 1;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background-color 0.14s ease, border-color 0.14s ease, color 0.14s ease, box-shadow 0.14s ease;\n}\n\n.awardTypesToolbar .awardTypesButton {\n  min-height: var(--control-h-md, 40px);\n  height: var(--control-h-md, 40px);\n}\n\n.awardTypesButton:disabled {\n  opacity: 0.65;\n  cursor: default;\n}\n\n.awardTypesButton .awardTypesIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.awardTypesButton--primary {\n  background: var(--brand-600, #227ebd);\n  border-color: var(--brand-600, #227ebd);\n  color: #fff;\n  box-shadow: none;\n}\n\n.awardTypesButton--primary:hover:not(:disabled) {\n  background: var(--brand-700, #17689f);\n  border-color: var(--brand-700, #17689f);\n}\n\n.awardTypesButton--ghost {\n  background: transparent;\n  border-color: transparent;\n  color: var(--text-link, #1a6da3);\n}\n\n.awardTypesButton--ghost:hover:not(:disabled) {\n  background: var(--blue-50, #eef6fc);\n  border-color: transparent;\n}\n\n.awardTypesButton--danger {\n  background: var(--red-500, #da4453);\n  border-color: transparent;\n  color: #fff;\n  box-shadow: none;\n}\n\n.awardTypesButton--danger:hover:not(:disabled) {\n  background: var(--red-600, #c4313f);\n}\n\n.awardTypesSelectionBar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  margin-bottom: 12px;\n  padding: 8px 14px;\n  border: 1px solid var(--blue-100, #d4e8f6);\n  border-radius: var(--radius-md, 8px);\n  background: var(--blue-50, #eef6fc);\n  box-shadow: none;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--blue-700, #155d8c);\n}\n\n.awardTypesSelectionBar__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.awardTypesGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 12px;\n}\n\n.awardTypesCard {\n  position: relative;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.06));\n  transition: box-shadow 0.15s ease, transform 0.15s ease, border-color 0.15s ease;\n}\n\n.awardTypesCard:hover {\n  border-color: var(--border-strong, #94a3b8);\n  box-shadow: var(--shadow-md, 0 4px 12px rgba(15, 23, 42, 0.09));\n}\n\n.awardTypesCard--selected {\n  border-color: var(--brand-300, #9cc4e8);\n  box-shadow: 0 0 0 3px var(--brand-100, #d6e7f6);\n}\n\n.awardTypesCard__body {\n  display: block;\n  width: 100%;\n  min-height: 168px;\n  padding: 14px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.awardTypesCard__checkbox {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 2;\n  width: 23px;\n  height: 23px;\n  margin: 0;\n  cursor: pointer;\n}\n\n.awardTypesCard__checkbox input {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.awardTypesCard__checkbox span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 23px;\n  height: 23px;\n  border: 1.5px solid var(--border-strong, #94a3b8);\n  border-radius: 6px;\n  background: var(--surface-card, #fff);\n  color: #fff;\n}\n\n.awardTypesCard__checkbox input:checked + span {\n  border-color: var(--brand-600, #227ebd);\n  background: var(--brand-600, #227ebd);\n}\n\n.awardTypesCard__checkbox .awardTypesIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 3;\n}\n\n.awardTypesCard__top {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding-right: 30px;\n  margin-bottom: 9px;\n}\n\n.awardTypesCard__main {\n  min-width: 0;\n}\n\n.awardTypesCard__name {\n  margin-bottom: 5px;\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n  line-height: 1.25;\n  font-weight: 800;\n}\n\n.awardTypesCard p {\n  min-height: 36px;\n  margin: 0 0 10px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.awardTypesCard__footer {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n  padding-top: 10px;\n  border-top: 1px solid var(--border-subtle, #dbe3ed);\n}\n\n.awardTypesTile {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  border: 1px solid var(--border-subtle, #dbe3ed);\n  border-radius: var(--radius-md, 8px);\n  overflow: hidden;\n  background: var(--surface-card, #fff);\n}\n\n.awardTypesTile img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.awardTypesTile--generated {\n  border-color: transparent;\n}\n\n.awardTypesTile--generated .awardTypesIcon {\n  width: 52%;\n  height: 52%;\n  stroke-width: 2;\n}\n\n.awardTypesPoints,\n.awardTypesStatus,\n.awardTypesMiniChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  line-height: 1;\n  font-weight: 800;\n}\n\n.awardTypesPoints {\n  background: var(--brand-50, #eaf4fb);\n  color: var(--brand-700, #17689f);\n}\n\n.awardTypesPoints--negative {\n  background: #fdeef0;\n  color: #c23648;\n}\n\n.awardTypesPoints .awardTypesIcon {\n  width: 13px;\n  height: 13px;\n  fill: currentColor;\n}\n\n.awardTypesStatus {\n  height: 22px;\n  padding: 0 9px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n}\n\n.awardTypesStatus--enabled {\n  background: #e7f3ec;\n  color: #2f9e5a;\n}\n\n.awardTypesStatus i {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--text-subtle, #94a3b8);\n}\n\n.awardTypesStatus--enabled i {\n  background: #2f9e5a;\n}\n\n.awardTypesMiniChip {\n  height: 22px;\n  padding: 0 8px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.awardTypesMiniChip--danger {\n  background: #fdeef0;\n  color: #c23648;\n}\n\n.awardTypesRolesCount {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin-left: auto;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 11.5px;\n  font-weight: 700;\n}\n\n.awardTypesRolesCount .awardTypesIcon {\n  width: 13px;\n  height: 13px;\n}\n\n.awardTypesDrawerOverlay,\n.awardTypesModalOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1040;\n  background: rgba(15, 23, 42, 0.28);\n}\n\n.awardTypesDrawerOverlay {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.awardTypesDrawer {\n  display: flex;\n  flex-direction: column;\n  width: min(500px, 100vw);\n  height: 100%;\n  background: var(--surface-card, #fff);\n  box-shadow: -14px 0 36px rgba(15, 23, 42, 0.18);\n}\n\n.awardTypesDrawer__header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 20px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ed);\n}\n\n.awardTypesDrawer__header h2 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-size: 18px;\n  line-height: 1.25;\n  font-weight: 800;\n}\n\n.awardTypesDrawer__header p {\n  margin: 3px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  font-weight: 650;\n}\n\n.awardTypesDrawer__header > div:nth-child(2) {\n  flex: 1;\n  min-width: 0;\n}\n\n.awardTypesIconButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-subtle, #dbe3ed);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n}\n\n.awardTypesDrawer__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 18px 20px 20px;\n}\n\n.awardTypesDrawer__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 20px;\n  border-top: 1px solid var(--border-subtle, #dbe3ed);\n  background: var(--surface-card, #fff);\n}\n\n.awardTypesPreviewCard {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  margin-bottom: 18px;\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #dbe3ed);\n  border-radius: 12px;\n  background: var(--slate-25, #f8fafc);\n}\n\n.awardTypesPreviewCard > div > div:first-child {\n  margin-bottom: 5px;\n  color: var(--text-strong, #0f172a);\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.awardTypesField {\n  margin-bottom: 17px;\n}\n\n.awardTypesField label {\n  display: block;\n  margin-bottom: 7px;\n  color: var(--text-strong, #0f172a);\n  font-size: 12.5px;\n  line-height: 1.2;\n  font-weight: 750;\n}\n\n.awardTypesInput {\n  width: 100%;\n  min-height: 42px;\n  padding: 0 13px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 9px;\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font: inherit;\n  font-size: 14px;\n}\n\n.awardTypesTextarea {\n  min-height: 82px;\n  padding-top: 10px;\n  line-height: 1.5;\n  resize: vertical;\n}\n\n.awardTypesInput:focus {\n  outline: none;\n  border-color: var(--brand-500, #227ebd);\n  box-shadow: 0 0 0 3px var(--brand-100, #d6e7f6);\n}\n\n.awardTypesArtworkRow {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.awardTypesArtworkRow p {\n  margin: 8px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n\n.awardTypesUploadButton {\n  position: relative;\n  display: inline-flex !important;\n  align-items: center;\n  gap: 7px;\n  width: auto;\n  height: 36px;\n  margin: 0 !important;\n  padding: 0 14px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155) !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  cursor: pointer;\n}\n\n.awardTypesUploadButton input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.awardTypesRemoveImage {\n  display: block;\n  margin-top: 8px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #c23648;\n  font: inherit;\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.awardTypesStepper {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.awardTypesStepper button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 9px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  cursor: pointer;\n}\n\n.awardTypesStepper input {\n  width: 76px;\n  height: 38px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 9px;\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font: inherit;\n  font-size: 16px;\n  font-weight: 800;\n  text-align: center;\n}\n\n.awardTypesSwitchGroup {\n  margin: 4px 0 18px;\n  border-top: 1px solid var(--border-subtle, #dbe3ed);\n  border-bottom: 1px solid var(--border-subtle, #dbe3ed);\n}\n\n.awardTypesSwitchRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 13px 0;\n}\n\n.awardTypesSwitchRow + .awardTypesSwitchRow {\n  border-top: 1px solid var(--border-subtle, #dbe3ed);\n}\n\n.awardTypesSwitchRow div div {\n  color: var(--text-strong, #0f172a);\n  font-size: 13.5px;\n  font-weight: 750;\n}\n\n.awardTypesSwitchRow p {\n  margin: 2px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n.awardTypesSwitch {\n  display: inline-flex;\n  justify-content: flex-start;\n  flex: 0 0 auto;\n  width: 46px;\n  height: 27px;\n  padding: 3px;\n  border: 0;\n  border-radius: 999px;\n  background: var(--slate-300, #cbd5e1);\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.awardTypesSwitch--on {\n  justify-content: flex-end;\n  background: var(--brand-600, #227ebd);\n}\n\n.awardTypesSwitch span {\n  width: 21px;\n  height: 21px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.3);\n}\n\n.awardTypesRolesGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 9px;\n}\n\n.awardTypesRoleChip {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  height: 42px;\n  padding: 0 12px;\n  border: 1px solid var(--border-subtle, #dbe3ed);\n  border-radius: 9px;\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font: inherit;\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.awardTypesRoleChip--selected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.awardTypesRoleChip span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 6px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-subtle, #94a3b8);\n}\n\n.awardTypesRoleChip--selected span {\n  background: var(--brand-600, #227ebd);\n  color: #fff;\n}\n\n.awardTypesRoleChip .awardTypesIcon {\n  width: 13px;\n  height: 13px;\n  stroke-width: 3;\n}\n\n.awardTypesAlert {\n  margin-bottom: 16px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.awardTypesAlert--danger {\n  border: 1px solid #f4c9cf;\n  background: #fdeef0;\n  color: #8f2c39;\n}\n\n.awardTypesModalOverlay {\n  z-index: 1060;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.45);\n}\n\n.awardTypesModal {\n  position: relative;\n  width: min(460px, 100%);\n  padding: 24px;\n  border: 1px solid var(--border-subtle, #dbe3ed);\n  border-radius: 16px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.22);\n}\n\n.awardTypesModal__close {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--border-subtle, #dbe3ed);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n}\n\n.awardTypesModal__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  margin-bottom: 14px;\n  border-radius: 12px;\n  background: #fdeef0;\n  color: #c23648;\n}\n\n.awardTypesModal h2 {\n  margin: 0 0 8px;\n  color: var(--text-strong, #0f172a);\n  font-size: 20px;\n  line-height: 1.25;\n  font-weight: 800;\n}\n\n.awardTypesModal p {\n  margin: 0 0 16px;\n  color: var(--text-body, #334155);\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.awardTypesModal__names {\n  margin-bottom: 18px;\n  padding: 11px 13px;\n  border-radius: 10px;\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.awardTypesModal__actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.awardTypesToast {\n  position: fixed;\n  left: 50%;\n  bottom: 24px;\n  z-index: 1080;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 18px;\n  border-radius: 10px;\n  background: #123651;\n  color: #fff;\n  font-size: 13.5px;\n  font-weight: 700;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.28);\n  transform: translateX(-50%);\n}\n\n.awardTypesToast .awardTypesIcon {\n  color: #4fd18b;\n}\n\n.awardTypesEmpty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 320px;\n  padding: 32px;\n  border: 1px solid var(--border-subtle, #dbe3ed);\n  border-radius: 16px;\n  background: var(--surface-card, #fff);\n  text-align: center;\n}\n\n.awardTypesEmpty > div {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 58px;\n  height: 58px;\n  margin-bottom: 14px;\n  border-radius: 15px;\n  background: var(--brand-50, #eaf4fb);\n  color: var(--brand-600, #227ebd);\n}\n\n.awardTypesEmpty h2 {\n  margin: 0 0 6px;\n  color: var(--text-strong, #0f172a);\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.awardTypesEmpty p {\n  max-width: 440px;\n  margin: 0 0 18px;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n@media (max-width: 760px) {\n  .awardTypesPage {\n    padding: 18px 14px 36px;\n  }\n\n  .awardTypesToolbar,\n  .awardTypesSelectionBar,\n  .awardTypesDrawer__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .awardTypesToolbar__right,\n  .awardTypesToolbar__heading,\n  .awardTypesSearch,\n  .awardTypesButton,\n  .awardTypesSelectionBar__actions {\n    width: 100%;\n  }\n\n  .awardTypesGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .awardTypesRolesGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Modern list screen */\n.awardTypesPage {\n  width: 100%;\n  min-height: 100%;\n  margin-top: 0 !important;\n  padding: 0 0 32px;\n  background: transparent;\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n}\n\n.awardTypesPageHeader {\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 70px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  margin: -20px 0 18px -24px;\n  padding: 0 72px 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.awardTypesPageHeader__title {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n}\n\n.awardTypesPageHeader h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.015em;\n  white-space: nowrap;\n}\n\n.awardTypesPageHeader__title > span {\n  display: inline-flex;\n  min-width: 24px;\n  height: 22px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11.5px;\n  font-weight: 800;\n}\n\n.awardTypesShell {\n  width: 100%;\n  max-width: none;\n}\n\n.awardTypesListCard {\n  position: relative;\n  overflow: visible;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.awardTypesListToolbar {\n  display: flex;\n  min-height: 64px;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px 12px 0 0;\n  background: var(--surface-card, #fff);\n}\n\n.awardTypesListToolbar .awardTypesSearch {\n  width: min(420px, 100%);\n  height: 38px;\n  margin-right: 0;\n  flex: 0 1 420px;\n}\n\n.awardTypesSearch > button {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.awardTypesButton--secondary {\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n}\n\n.awardTypesButton--secondary:hover:not(:disabled),\n.awardTypesButton--secondary.is-active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.awardTypesListToolbar .awardTypesButton {\n  height: 38px;\n  min-height: 38px;\n}\n\n.awardTypesButton__badge {\n  display: inline-flex;\n  min-width: 20px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.awardTypesButton--secondary.is-active .awardTypesButton__badge {\n  background: var(--surface-card, #fff);\n}\n\n.awardTypesColumns {\n  position: relative;\n}\n\n.awardTypesColumnsMenu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 30;\n  width: 260px;\n  padding: 8px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.16);\n}\n\n.awardTypesColumnsMenu header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 7px 8px 9px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  color: var(--text-strong, #0f172a);\n  font-size: 12px;\n}\n\n.awardTypesColumnsMenu header button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--blue-700, #155d8c);\n  font: inherit;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.awardTypesColumnsMenu label {\n  display: flex;\n  min-height: 38px;\n  align-items: center;\n  gap: 9px;\n  margin: 0;\n  padding: 0 8px;\n  border-radius: 7px;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.awardTypesColumnsMenu label:hover {\n  background: var(--surface-sunken, #f1f5f9);\n}\n\n.awardTypesColumnsMenu label.is-locked {\n  color: var(--text-muted, #64748b);\n  cursor: default;\n}\n\n.awardTypesColumnsMenu label input,\n.awardTypesTable input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--action-primary, #227ebd);\n}\n\n.awardTypesColumnsMenu label small {\n  margin-left: auto;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.awardTypesActiveFilters {\n  display: flex;\n  min-height: 44px;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 8px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.awardTypesActiveFilters > span {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  gap: 4px;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n}\n\n.awardTypesActiveFilters > span b {\n  font-weight: 800;\n}\n\n.awardTypesActiveFilters button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.awardTypesActiveFilters > span button {\n  margin-left: 3px;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.awardTypesActiveFilters > button {\n  margin-left: 2px;\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n}\n\n.awardTypesListCard .awardTypesSelectionBar {\n  min-height: 48px;\n  margin: 0;\n  padding: 8px 16px;\n  border-width: 0 0 1px;\n  border-color: var(--blue-100, #d4e8f6);\n  border-radius: 0;\n}\n\n.awardTypesListCard .awardTypesSelectionBar__actions {\n  margin-left: auto;\n}\n\n.awardTypesTableScroll {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.awardTypesTable {\n  width: 100%;\n  min-width: 900px;\n  border-collapse: collapse;\n  table-layout: auto;\n}\n\n.awardTypesTable th {\n  height: 44px;\n  padding: 0 14px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.045em;\n  text-align: left;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.awardTypesTable th > button {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  cursor: pointer;\n}\n\n.awardTypesTable th > button span {\n  color: var(--text-subtle, #94a3b8);\n  font-size: 12px;\n}\n\n.awardTypesTable th > button span.is-active {\n  color: var(--action-primary, #227ebd);\n}\n\n.awardTypesTable td {\n  height: 56px;\n  padding: 8px 14px;\n  border-bottom: 1px solid var(--border-subtle, #e8edf2);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.awardTypesTable tbody tr {\n  cursor: pointer;\n}\n\n.awardTypesTable tbody tr:hover,\n.awardTypesTable tbody tr.is-selected,\n.awardTypesTable tbody tr:focus {\n  background: var(--blue-50, #eef6fc);\n}\n\n.awardTypesTable tbody tr:focus {\n  outline: 2px solid var(--action-primary, #227ebd);\n  outline-offset: -2px;\n}\n\n.awardTypesTable__check {\n  width: 46px;\n  padding-right: 6px !important;\n  text-align: center !important;\n}\n\n.awardTypesTable__award {\n  min-width: 320px;\n}\n\n.awardTypesAwardCell {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 11px;\n}\n\n.awardTypesAwardCell > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.awardTypesAwardCell strong {\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-size: 13.5px;\n  font-weight: 800;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.awardTypesAwardCell small {\n  display: block;\n  max-width: 460px;\n  overflow: hidden;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  line-height: 1.3;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.awardTypesTable .awardTypesTile {\n  border-radius: 8px;\n}\n\n.awardTypesRoleList,\n.awardTypesSettingsList {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n\n.awardTypesRoleList span,\n.awardTypesSettingsList span {\n  display: inline-flex;\n  min-height: 22px;\n  align-items: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-body, #334155);\n  font-size: 10.5px;\n  font-weight: 750;\n  white-space: nowrap;\n}\n\n.awardTypesSettingsList span {\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.awardTypesSettingsList span.is-danger {\n  background: #fdeef0;\n  color: #a7283b;\n}\n\n.awardTypesRoleList em,\n.awardTypesSettingsList em {\n  color: var(--text-subtle, #94a3b8);\n  font-size: 12px;\n  font-style: normal;\n}\n\n.awardTypesTable__date {\n  color: var(--text-muted, #64748b) !important;\n  white-space: nowrap;\n}\n\n.awardTypesTable__open {\n  width: 40px;\n  padding-right: 12px !important;\n  padding-left: 0 !important;\n  text-align: center !important;\n}\n\n.awardTypesTable__open span {\n  opacity: 0;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 24px;\n  line-height: 1;\n  transition: opacity 0.12s ease;\n}\n\n.awardTypesTable tbody tr:hover .awardTypesTable__open span,\n.awardTypesTable tbody tr:focus-within .awardTypesTable__open span {\n  opacity: 1;\n}\n\n.awardTypesTable__empty {\n  height: auto !important;\n  padding: 32px 14px !important;\n  color: var(--text-muted, #64748b) !important;\n  text-align: center;\n}\n\n.awardTypesPagination {\n  display: flex;\n  min-height: 58px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  padding: 10px 16px;\n  border-radius: 0 0 11px 11px;\n  background: var(--surface-card, #fff);\n}\n\n.awardTypesPagination > span {\n  margin-right: auto;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.awardTypesPagination button {\n  min-width: 34px;\n  height: 34px;\n  padding: 0 10px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.awardTypesPagination button:hover:not(:disabled),\n.awardTypesPagination button.is-active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.awardTypesPagination button:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.awardTypesFilterOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: flex;\n  justify-content: flex-end;\n  background: rgba(15, 23, 42, 0.24);\n}\n\n.awardTypesFilterDrawer {\n  display: flex;\n  width: min(440px, calc(100vw - 32px));\n  height: 100vh;\n  flex-direction: column;\n  border-left: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.awardTypesFilterDrawer > header {\n  display: flex;\n  min-height: 76px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 18px 22px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.awardTypesFilterDrawer > header h2 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, inherit);\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.awardTypesFilterDrawer > header button {\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-muted, #64748b);\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.awardTypesFilterDrawer__body {\n  display: flex;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 22px;\n  overflow-y: auto;\n  padding: 20px 22px 28px;\n}\n\n.awardTypesFilterDrawer__body .people-chipFilter + .people-chipFilter {\n  padding-top: 18px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.awardTypesFilterDrawer__body .people-chipFilter__body {\n  max-height: none;\n  overflow: visible;\n}\n\n.awardTypesFilterDrawer > footer {\n  display: flex;\n  min-height: 66px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 16px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fafbfc);\n}\n\n.awardTypesFilterDrawer > footer > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.awardTypesEmpty {\n  border-radius: var(--radius-lg, 12px);\n}\n\n@media (max-width: 1217px) {\n  .awardTypesPageHeader {\n    width: 100vw;\n    margin-left: -12px;\n    padding-right: 28px;\n  }\n}\n\n@media (max-width: 760px) {\n  .awardTypesPage {\n    padding: 0 0 24px;\n  }\n\n  .awardTypesPageHeader {\n    min-height: 74px;\n    align-items: center;\n    margin-bottom: 14px;\n    padding: 10px 16px;\n  }\n\n  .awardTypesPageHeader .awardTypesButton {\n    width: auto;\n    flex: 0 0 auto;\n  }\n\n  .awardTypesListToolbar {\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n\n  .awardTypesListToolbar .awardTypesSearch {\n    width: 100%;\n    flex: 1 0 100%;\n  }\n\n  .awardTypesColumns {\n    flex: 1 1 auto;\n  }\n\n  .awardTypesColumns > .awardTypesButton,\n  .awardTypesListToolbar > .awardTypesButton {\n    width: 100%;\n  }\n\n  .awardTypesColumnsMenu {\n    right: 0;\n    left: auto;\n  }\n\n  .awardTypesListCard .awardTypesSelectionBar {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .awardTypesListCard .awardTypesSelectionBar__actions {\n    width: auto;\n  }\n\n  .awardTypesListCard .awardTypesSelectionBar .awardTypesButton {\n    width: auto;\n  }\n\n  .awardTypesFilterDrawer {\n    width: 100vw;\n  }\n\n  .awardTypesFilterDrawer > footer {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .awardTypesFilterDrawer > footer > div,\n  .awardTypesFilterDrawer > footer .awardTypesButton {\n    width: 100%;\n  }\n\n  .awardTypesFilterDrawer > footer > div .awardTypesButton {\n    flex: 1 1 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
